import { Drawer } from 'antd';
import { Button } from 'components/Button';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { leaveStatusOptions } from 'utils/constants';

const LeaveFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    leaveTypes,
    handleDateChange,
    handleClearAll,
    isFilterDirty


}) => {
  const [placement] = useState('right');  
   const {
    userData, userDataLoading,
    department, departmentLoading,

    costCenter, costCenterLoading,

    currentApprovers, currentApproversLoading
} = useSelector((state) => state.common);



const [userDataOption, setUserDataOption] = useState([]);


const [departmentOption, setDepartmentOption] = useState([]);


const [costCenterOption, setCostCenterOption] = useState([]);


const [currentApproverOption, setCurrentApproverOption] = useState([]);



useEffect(()=>{
   
    let _userData = userData?.map(item=> {
        return{
            label: item.first_name+" "+item.last_name,
            value: item.id
        }
    })

    let _departments = department.map(item=> {
        return{
            label: item.name,
            value: item.id
        }
    })

    let cost_center = costCenter.map(item=> {
        return{
            label: item.code,
            value: item.id
        }
    })

    let _currentApprovers = (currentApprovers || []).map(item=> {
        return{
            label: item.emp_no ? `${item.name} (${item.emp_no})` : item.name,
            value: item.id
        }
    })

    setUserDataOption(_userData)


    setDepartmentOption(_departments)

    setCostCenterOption(cost_center)

    setCurrentApproverOption(_currentApprovers)

},[userData, department, costCenter, currentApprovers])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);



  return (
    <>
      <Drawer
        title="Filters"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
        footer={
          <div>
            {filters.some(filter => filter.value && filter.key !== "search") && (
              <Button
                label="Clear All"
                onClick={handleClearAll}
                className="btn btn-link w-100 mb-2 p-0"
                style={{ color: "var(--brand-text-muted)", fontWeight: 600 }}
              />
            )}
            <Button label="Apply Filter" loading={filterLoading} disabled={filterLoading || !isFilterDirty} onClick={handleApplyFilter} className="btn btn-primary w-100" style={{ borderRadius: "8px" }} />
          </div>
        }
      >


        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "approval_status")}} optionLabel={"label"} optionValue={'value'} options={leaveStatusOptions} value={setFilterValue("approval_status")} placeholder={"Approval status"}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "leave_type")}} optionLabel={"label"} optionValue={'value'} isLoading={false} value={setFilterValue("leave_type")} options={leaveTypes}  placeholder={"Leave type"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'}  options={userDataOption} isLoading={userDataLoading}  value={setFilterValue("company_user")} placeholder={"User"}/>
        </div>

        <div className='col-12 mb-3' >
        <FilterSelect isClearable={true}  onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'}  options={departmentOption} isLoading={departmentLoading}  value={setFilterValue("department")} placeholder={"Department"}/>
        </div>



        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption}  value={setFilterValue("cost_center")} placeholder={"Cost Center"} isLoading={costCenterLoading}/>
        </div>


        <div className='col-12 mb-3' >
        <FilterSelect  isClearable={true} onChange={e=>{handleFilterChange(e, "current_approver")}} optionLabel={"label"} optionValue={'value'} options={currentApproverOption}  value={setFilterValue("current_approver")} placeholder={"Current Approver"} isLoading={currentApproversLoading}/>
        </div>

      

      </Drawer>
    </>
  );
};
export default LeaveFilterDrawer;